export function createSession(userConnection) {
    return {
        id: userConnection.tenant,
        userId: userConnection.id,
        userToken: userConnection.token
    };
}